<template>
  <div data-test="loader" class="e-loader">
    <div />
    <div />
    <div />
    <div />
  </div>
</template>
